<!-- Trip Distribution modal -->
<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <!-- Background Overlay -->
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
        <div class="w-screen max-w-xl px-4 py-4">
          <!-- Modal Content -->
          <div class="flex flex-col overflow-y-auto px-4 py-4">
            <div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
              <!-- Background Overlay -->
              <div
                class="fixed inset-0 bg-[#D4D7DE] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]">
              </div>
              <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                  <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                    <div class="w-screen max-w-screen-2xl overflow-hidden p-4">
                      <!-- Modal Container -->
                      <div
                        class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
                          <div class="flex items-center justify-between">
                            <h3 class="heading" id="slide-over-title">{{source ==='cancel' || source === 'fundingsourceBilling'? "Cancel" : 'Reroute'}}</h3>
                            <div class="ml-3 flex h-7 items-center space-x-4">
                              <button (click)="onCloseModal()"
                                class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                type="button">
                                <span class="sr-only">Close panel</span>
                                <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor"
                                  stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="flex flex-1 flex-col gap-4 overflow-hidden p-4 lg:flex-row">
                          <div class="h-full w-full flex-1 overflow-y-auto flex flex-col p-2">
                            <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                              <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
                                <div class="relative">
                                  <input type="text" placeholder="Search.." class="pl-8" [(ngModel)]="search" />
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor"
                                    class="absolute left-2 top-1/2 size-5 -translate-y-1/2 transform">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                                  </svg>
                                </div>
                              </div>
                              <div>
                                <h1 class="text-xs text-nowrap text-left">Showing {{trips.length}} entries</h1>
                              </div>
                            </div>

                            <div class="w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
                              <div class="flow-root h-full overflow-y-auto">
                                <div class="-my-2">
                                  <div class="inline-block min-w-full py-2 align-middle">
                                    <table class="min-w-full border-separate border-spacing-0">
                                      <thead>
                                        <tr>
                                           <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                          #
                                          </th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Reference ID
                                          </th>


                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Company</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Status</th>
                                          <!-- <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Driver</th> -->
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Member</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Contact No.</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Pickup Time
                                          </th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Pickup Address</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Dropoff Time
                                          </th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Dropoff Address</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Miles</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Service Area</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Space Type</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            LOS</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Appointment Type</th>


                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Created At </th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            General Notes</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let trip of trips | filter:search; let i=index"
                                          class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                        
                                         <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{i+1}}
                                          </td>
                                          <!-- Reference -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span>
                                              {{trip.reference || 'N/A'}} - {{trip.suffix || 'N/A'}}
                                            </span>
                                          </td>
                                          <!-- company -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preCompanies && preCompanies[trip.company]">
                                              {{preCompanies[trip.company].name | titlecase}}
                                            </span>
                                          </td>
                                          <!-- status -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span class="my-1" [ngClass]="{
                                          'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                          'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                        }"> {{trip.status | titlecase}} </span>
                                          </td>
                                          <!-- driver -->
                                          <!-- <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip.driver ? trip.driver : 'N/A'}}</td> -->
                                          <!-- member -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="trip.member && trip.member.displayName; else noMember">
                                              {{(trip?.member?.displayName) | titlecase}}
                                            </span>
                                            <ng-template #noMember>
                                              <span *ngIf="member">{{ member?.displayName | titlecase}}</span>
                                            </ng-template>
                                          </td>
                                          <!-- phoneNumber -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="trip?.pickup.phoneNumber">
                                            {{trip?.pickup.phoneNumber || 'N/A'}}</td>
                                          <!-- pickuptime -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.pickup.time | date: 'MM/DD/YYYY HHmm'}}</td>
                                          <!-- pickup address -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.pickup?.address?.name}}</td>
                                          <!-- DO time -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.pickup.time | date: 'MM/DD/YYYY HHmm'}}</td>
                                          <!-- destination address -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.destination?.address?.name}}</td>
                                          <!-- miles -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}</td>

                                          <!-- Service Areas -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                                              {{preServiceAreas[trip.serviceArea].title ?
                                              (preServiceAreas[trip.serviceArea].title | titlecase) : 'N/A'}}
                                            </span>
                                          </td>

                                          <!-- spaceType -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType]">
                                              {{preSpacetypes[trip.spaceType].title | uppercase}}
                                            </span>
                                          </td>
                                          <!-- LOS -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]; else elseBlock">
                                              {{preLevelOfService[trip.levelOfService].title | uppercase}}
                                            </span>
                                            <ng-template #elseBlock>
                                              N/A
                                            </ng-template>
                                            
                                          </td>
                                          <!-- appointmentType -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span
                                              *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]">
                                              {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                                            </span>
                                          </td>
                                          <!-- createdAt -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip.createdAt | date: 'MM/DD/YYYY'}}</td>
                                          <!-- generalNotes -->
                                          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                             <div class="w-72 line-clamp-2">
                                                {{trip.generalNotes || 'N/A'}}
                                              </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>



                          </div>
                          <div class="flex-1 flex flex-col overflow-y-auto">
                            <ul role="list" class="">
                              <form *ngIf="cancelReasons.length" action="" class="space-y-6">
                                <div>
                                   <label for="all-reason" class="block text-sm font-semibold text-main-secondary">Reasons</label>
                                     <fieldset>
                                  <legend class="sr-only">Notification method</legend>
                                  <div class="mt-1 flex flex-wrap gap-2 items-start ">
                                    <div *ngFor="let reason of cancelReasons"
                                      class=" flex items-center border border-dashed rounded bg-gray-50 py-1 px-2 dark:bg-white/5 dark:border-white/10">
                                      <input class="cursor-pointer " [checked]="cancelReason === reason.title" (click)="setReason(reason.title)"
                                        [id]="reason.id" name="cancel-reason" type="radio" [value]="reason.title" />
                                      <label [for]="reason.id"
                                        class="cursor-pointer  ml-3 block text-sm font-medium text-main-secondary">{{ reason.title | titlecase
                                        }}</label>
                                    </div>

                                  </div>
                                </fieldset>
                                </div>
                                
                                <!-- Billable Reason -->
                                 <ng-container *ngIf="billAbleReasons.length">
                                  <div>
                                   <label for="all-reason" class="block text-sm font-semibold text-main-secondary">Billable Reasons</label>
                                     <fieldset>
                                  <legend class="sr-only">Billable Reasons</legend>
                                  <div class="mt-1 flex flex-wrap gap-2 items-start ">
                                    <div *ngFor="let reason of billAbleReasons"
                                      class="flex items-center border border-dashed rounded bg-gray-50 py-1 px-2 dark:bg-white/5 dark:border-white/10">
                                      <input class="cursor-pointer" [checked]="cancelReason === reason.title" (click)="setReason(reason.title)"
                                        [id]="reason.id" name="cancel-reason" type="radio" [value]="reason.title" />
                                      <label [for]="reason.id"
                                        class="cursor-pointer ml-3 block text-sm font-medium text-main-secondary">{{ reason.title | titlecase
                                        }}</label>
                                    </div>

                                  </div>
                                </fieldset>
                                </div>
                                </ng-container>
                                    <!-- noshow reaons -->
                                     <ng-container *ngIf="noshowReasons.length">
                                  <div>
                                   <label for="all-reason" class="block text-sm font-semibold text-main-secondary">Noshow
                                    Reasons</label>
                                     <fieldset>
                                  <legend class="sr-only">Noshow Reason</legend>
                                  <div class="mt-1 flex flex-wrap gap-2 items-start ">
                                    <div *ngFor="let reason of noshowReasons"
                                      class="flex items-center border border-dashed rounded bg-gray-50 py-1 px-2 dark:bg-white/5 dark:border-white/10">
                                      <input class="cursor-pointer" [checked]="cancelReason === reason.title" (click)="setReason(reason.title)"
                                        [id]="reason.id" name="cancel-reason" type="radio" [value]="reason.title" />
                                      <label [for]="reason.id"
                                        class="cursor-pointer ml-3 block text-sm font-medium text-main-secondary">{{ reason.title | titlecase
                                        }}</label>
                                    </div>

                                  </div>
                                </fieldset>
                                </div>
                                </ng-container>
                                <div>
                                  <label for="other-reason" class="block text-sm font-medium text-main-secondary">Other
                                    Reason</label>
                                  <div class="mt-1">
                                    <textarea [(ngModel)]="cancelReason" (ngModelChange)="onCustomReasonChange($event)" rows="4" name="other-reason"
                                      class="resize-none form-control" id="example-textarea"></textarea>
                                  </div>
                                  <p *ngIf="!cancelReason || cancelReason === ''" class="mt-4 text-xs text-red-600">
                                     Kindly select the reason for {{ source === 'cancel' ? 'cancellation' : 'reroute' }}.
                                  </p>
                                </div>

                              </form>
                            </ul>
                          </div>
                        </div>
                        <div class="border-t border-zinc-200 px-4 py-2 dark:border-white/10">
                          <div class="flex items-center justify-end gap-2">
                            <div class="flex gap-2">

                              <ng-container *ngIf="source !== 'reroute'">
                              <!-- billable toggle -->
                              <div  class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                                <label class="subheading">Billable</label>
                                <div class="flex items-center mt-2">
                                  <label
                                    class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-gray-300 bg-gray-200 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        
                                    <!-- ngModel binding -->
                                    <input type="checkbox" [(ngModel)]="isBillable" class="sr-only peer" />
                        
                                    <!-- Track -->
                                    <span
                                      class="absolute left-0 top-0 h-6 w-12 rounded-full transition-colors duration-200 ease-in-out bg-gray-300 peer-checked:bg-green-500"></span>
                        
                                    <!-- Thumb -->
                                    <span
                                      class="absolute left-0 top-0 h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ease-in-out peer-checked:translate-x-6 flex items-center justify-center">
                        
                                      <!-- Cross icon when OFF -->
                                      <svg *ngIf="!isBillable" class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round" />
                                      </svg>
                        
                                      <!-- Check icon when ON -->
                                      <svg *ngIf="isBillable" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                      </svg>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <!-- No show Toggle -->
                              <div  class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                                <label class="subheading">No Show</label>
                                <div class="flex items-center mt-2">
                                  <label
                                    class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-gray-300 bg-gray-200 text-sm-dark transition-colors duration-200 ease-in-out">
                              
                                    <input type="checkbox" [(ngModel)]="isNoShow" class="sr-only peer" />
                              
                                    <span
                                      class="absolute left-0 top-0 h-6 w-12 rounded-full bg-gray-300 peer-checked:bg-red-500 transition-colors"></span>
                              
                                    <span
                                      class="absolute left-0 top-0 h-6 w-6 bg-white rounded-full shadow transform transition-transform peer-checked:translate-x-6 flex items-center justify-center">
                              
                                      <!-- Cross icon when OFF -->
                                      <svg *ngIf="!isNoShow" class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round" />
                                      </svg>
                              
                                      <!-- Check icon when ON -->
                                      <svg *ngIf="isNoShow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                        stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                      </svg>
                              
                                    </span>
                                  </label>
                                </div>
                              </div>
                              
                              </ng-container>
                        
                              <button [disabled]="!cancelReason || cancelReason === ''" type="button" class="btn btn-danger" (click)="cancel()"
                                data-dismiss="modal">Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>